import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import styled from 'styled-components';

import { Title } from '../style';
import General from './section/general/General';
// import Address from './section/address/Address';
import Collaborator from './section/collaborator/Collaborator';
import PhoneNumber from './section/phoneNumber/PhoneNumber';
import AccountType from './section/accountType/AccountType';

const CustomPaper = styled(Paper)`
  padding-top: 20px;
  min-height: 80vh;
  position: relative;
`;

const UserProfile = () => {
  const [currentMenu, setCurrentMenu] = useState(0);
  return (
    <div>
      <Title>Mon profil</Title>
      <CustomPaper>
        <Grid container spacing={10}>
          <Grid item md={3}>
            <MenuList>
              <MenuItem
                selected={currentMenu === 0}
                onClick={() => setCurrentMenu(0)}
              >
                Général
              </MenuItem>
              <MenuItem
                selected={currentMenu === 1}
                onClick={() => setCurrentMenu(1)}
              >
                Numéro de téléphone
              </MenuItem>
              {/* Section d'ajout d'adresse
                <MenuItem
                  selected={currentMenu === 2}
                  onClick={() => setCurrentMenu(2)}
                  >
                  Mes adresses
                </MenuItem>
                */}
              <MenuItem
                selected={currentMenu === 2}
                onClick={() => setCurrentMenu(2)}
              >
                Collaborateur
              </MenuItem>
              <MenuItem
                selected={currentMenu === 3}
                onClick={() => setCurrentMenu(3)}
              >
                Type de compte
              </MenuItem>
            </MenuList>
          </Grid>
          <Grid item md={9}>
            {currentMenu === 0 && <General />}
            {currentMenu === 1 && <PhoneNumber />}
            {/* {currentMenu === 2 && <Address />} */}
            {currentMenu === 2 && <Collaborator />}
            {currentMenu === 3 && <AccountType />}
          </Grid>
        </Grid>
      </CustomPaper>
    </div>
  );
};

export default UserProfile;
